<template>
  <div>
    <template v-if="print_mode">
      <h2
        v-if="title_lv === 1"
        :class="[
          'mb-4 fw-700  text-left border-bottom-gray-900 gray-1000 pb-2 title-lv1 break-word',
          isFirstLv1 ? 'page-no-break-before' : 'page-break-before'
        ]"
      >
        {{ main_title }}
      </h2>

      <h3
        v-if="title_lv === 2"
        class="my-3 fw-700 text-left break-word page-no-break-after"
        :style="`color: ${mainColor}`"
      >
        {{ main_title }}
      </h3>

      <h4
        v-if="title_lv === 3"
        class="fw-600 text-left break-word page-no-break-after"
        :style="`color: ${selected_report.sub_color}`"
      >
        {{ main_title }}
      </h4>

      <h5
        v-if="title_lv === 5"
        class="fw-600 text-left gray-900 pt-2 break-word page-no-break-after"
      >
        {{ main_title }}
      </h5>

      <h6
        v-if="title_lv === 4"
        class="mb-0 fw-600 text-left gray-800 pt-2 break-word page-no-break-after"
      >
        {{ main_title }}
      </h6>
    </template>

    <template v-else>
      <div :id="!print_mode ? 'title_' + link : null">
        <h1 v-if="title_lv === 1" class="mb-3 fw-700 border-bottom-gray-900 gray-1000 pb-2">
          {{ main_title }}
        </h1>

        <h2 v-if="title_lv === 2" class="mb-3 fw-700" :style="`color: ${mainColor}`">
          {{ main_title }}
        </h2>

        <h3
          v-if="title_lv === 3"
          class="mb-0 fw-700"
          :style="`color: ${selected_report.sub_color}`"
        >
          {{ main_title }}
        </h3>

        <h4 v-if="title_lv === 5" class="mb-0 fw-600 gray-900">
          {{ main_title }}
        </h4>

        <h5 v-if="title_lv === 4" class="mb-0 fw-600 gray-800">
          {{ main_title }}
        </h5>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Title',
  props: {
    main_title: { type: String, default: '' },
    link: { type: String, default: '' },
    title_lv: { type: Number, default: 1 },
    print_mode: { type: Boolean, default: false },
    isFirstLv1: { type: Boolean, default: false },
    prevTitleLv: { type: Number, default: null },
    lv1_info: { type: Object, default: null }
  },
  mounted() {
    if (!this.print_mode) {
      this.setMarginForTitle();
    }
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('story_board', ['selected_lv1', 'selected_lv2']),
    mainColor() {
      const lv1Color = this.lv1_info?.background_color ?? this.selected_lv1?.background_color;
      if (lv1Color && lv1Color !== '#014555') {
        return lv1Color;
      }
      return this.selected_report?.main_color || '#008C95';
    }
  },
  methods: {
    setMarginForTitle() {
      let marginTop = '0';

      if (this.title_lv === 1) {
        marginTop = this.isFirstLv1 ? '0' : '3.25rem';
      } else if (this.title_lv === 2) {
        marginTop = this.prevTitleLv === 1 ? '0' : '2.25rem';
      } else if (this.title_lv === 3) {
        marginTop = this.prevTitleLv === 2 ? '0' : '1.75rem';
      } else if (this.title_lv === 4) {
        marginTop = this.prevTitleLv === 5 ? '0' : '1.25rem';
      } else if (this.title_lv === 5) {
        marginTop = this.prevTitleLv === 3 ? '0' : '1.5rem';
      }

      this.$el.style.marginTop = marginTop;
    }
  }
};
</script>

<style scoped>
.break-word {
  white-space: normal !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
